import React from "react"
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material"

const DialogBoxComponent = ({
  open,
  onClose,
  header,
  body,

  paperStyle = { minWidth: "400px" }, // Optional paper styling
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="custom-dialog-title"
      PaperProps={{
        style: paperStyle, 
      }}
    >
      <DialogTitle id="custom-dialog-title">{header}</DialogTitle>

      <DialogContent>{body}</DialogContent>


    </Dialog>
  )
}

export default DialogBoxComponent
